import React from "react";
import { Link } from "react-router-dom";

const About: React.FC = () => {
  // Team members data
  const teamMembers = [
    {
      name: "Manoj Kumar Singh",
      role: "Founder & Director",
    },
    {
      name: "Priya Sharma",
      role: "Program Manager",
      image: "https://placehold.co/300x300/10B981/FFFFFF/webp?text=Priya",
    },
    {
      name: "Rajesh Verma",
      role: "Financial Director",
      image: "https://placehold.co/300x300/F59E0B/FFFFFF/webp?text=Rajesh",
    },
    {
      name: "Neha Patel",
      role: "Outreach Coordinator",
      image: "https://placehold.co/300x300/EF4444/FFFFFF/webp?text=Neha",
    },
  ];

  // Historical milestones
  const milestones = [
    {
      year: "1999",
      title: "Foundation",
      description:
        "Our NGO was founded with a mission to create positive change in rural communities.",
    },
    {
      year: "2013",
      title: "First Women Empowerment Program",
      description:
        "Launched our first dedicated program for women's skill development and financial independence.",
    },
    {
      year: "2015",
      title: "Rural Sanitation Initiative",
      description:
        "Expanded our work to include sanitation facilities and hygiene education in rural areas.",
    },
    {
      year: "2017",
      title: "Cancer Awareness Campaign",
      description:
        "Started our cancer detection and support program in underserved communities.",
    },
    {
      year: "2020",
      title: "Digital Education Projects",
      description:
        "Introduced digital literacy programs in rural schools to bridge the technology gap.",
    },
    {
      year: "2023",
      title: "National Recognition",
      description:
        "Received national award for our contribution to the Swachh Bharat Mission.",
    },
  ];

  return (
    <>
      {/* Hero Banner */}
      <section className="relative bg-gray-900 py-16 md:py-24">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-80"></div>
        </div>
        <div className="relative container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            About Us
          </h1>
          <p className="text-white/90 text-lg max-w-3xl mx-auto">
            Learn about our mission, our history, and the team dedicated to
            creating positive change.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">
                Our Mission & Vision
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Founded in 1999, Lifeline Foundation NGO is dedicated to
                empowering women, educating communities, and promoting
                sustainable development in rural areas. Our dedicated team works
                tirelessly to create lasting positive change.
              </p>
              <div className="space-y-4">
                <div className="border-l-4 border-primary pl-4">
                  <h3 className="text-xl font-semibold mb-2">Our Mission</h3>
                  <p className="text-gray-600">
                    To empower communities through education, healthcare, and
                    sustainable development projects, with a focus on women and
                    marginalized groups.
                  </p>
                </div>
                <div className="border-l-4 border-secondary pl-4">
                  <h3 className="text-xl font-semibold mb-2">Our Vision</h3>
                  <p className="text-gray-600">
                    A world where all individuals, regardless of gender,
                    location, or economic status, have access to education,
                    healthcare, and opportunities for growth.
                  </p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="/volunteering.avif"
                alt="Our Mission - Volunteering Team"
                className="rounded-lg shadow-lg w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="section-padding bg-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
              Our Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our dedicated team of professionals works tirelessly to bring
              positive change to communities in need.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img
                  src="/h.avif.avif"
                  alt="Mr. Harsh Mishra"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2">Mr. Harsh Mishra</h3>
              <p className="text-primary font-medium mb-2">President</p>
              <p className="text-gray-600">
                Manages global outreach programs, fostering international
                partnerships and collaborations.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img
                  src="/ms.avif.avif"
                  alt="Mr. Manoj Singh"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2">Mr. Manoj Singh</h3>
              <p className="text-primary font-medium mb-2">General Secretary</p>
              <p className="text-gray-600">
                Leads the organization with strategic vision, guiding all major
                projects and initiatives.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img
                  src="/sm.avif.avif"
                  alt="Ms. Saleha Shaikh"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2">Ms. Saleha Shaikh</h3>
              <p className="text-primary font-medium mb-2">
                Vice President International
              </p>
              <p className="text-gray-600">
                Directs international programs, focusing on local community
                development and impact.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img
                  src="/sg.avif.avif"
                  alt="Ms. Shaivi Pandey"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2">Ms. Shaivi Pandey</h3>
              <p className="text-primary font-medium mb-2">
                Vice President National
              </p>
              <p className="text-gray-600">
                Directs national programs, focusing on local community
                development and impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our History */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
              Our Journey
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Since our founding in 1999, we've been on a mission to create
              positive change. Here are some key milestones in our journey.
            </p>
          </div>

          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                } gap-8 items-center`}
              >
                <div className="md:w-1/3 text-center">
                  <span className="inline-block bg-primary text-white text-4xl font-bold py-4 px-6 rounded-lg">
                    {milestone.year}
                  </span>
                </div>
                <div className="md:w-2/3">
                  <h3 className="text-2xl font-semibold text-dark mb-2">
                    {milestone.title}
                  </h3>
                  <p className="text-gray-600">{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-r from-primary to-secondary text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Join Our Mission
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            Whether through donations, volunteering, or partnerships, your
            support helps us continue our work for communities in need.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/donate"
              className="bg-white text-primary font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Donate Now
            </Link>
            <a
              href="mailto:contact@lifelinefoundation.org"
              className="bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-lg hover:bg-white/10 transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <div className="text-center">
        <p className="text-lg mb-4">
          Have questions? We'd love to hear from you.
        </p>
        <a
          href="mailto:contact@lifelinefoundation.org"
          className="btn-primary inline-block"
        >
          Get in Touch
        </a>
      </div>
    </>
  );
};

export default About;
